import angular from 'angular';
import '../../shared.module';
import template from './tabs.component.html';
import './tabs.component.scss';

class TabsController {
  select(tab) {
    if (tab.id === this.activeId) return;
    this.activeId = tab.id;
    if (this.onChange) this.onChange({ tabId: tab.id });
  }
}

angular.module('app.shared').component('cpTabs', {
  bindings: {
    tabs: '<',
    activeId: '<',
    onChange: '&'
  },
  controller: TabsController,
  controllerAs: 'vm',
  template
});
